import { render, staticRenderFns } from "./ListarGerencias.vue?vue&type=template&id=63d4d16a&"
import script from "./ListarGerencias.vue?vue&type=script&lang=js&"
export * from "./ListarGerencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports